import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class ProjectAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'Projects';

  /**
   * Get dữ liệu chuyển từ nguồn
   * @returns
   */
  async fromProject(param = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/list',
      data: {
        Skip: 0,
        Take: 100,
        Sort: 'project_code',
        Columns: 'project_name,project_code,project_id',
        Filter: '[{"Field":"parent_id","Operator":"NOT NULL"}]',
        type: 0,
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Get dữ liệu chuyển từ ctmt/dự án
   * @returns
   */
  async changeProject(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/changeProject',
      data: {
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * kiểm tra phát sinh CTMTDA
   * @returns 
   */
   async checkAriseProject(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/checkAriseProject',
      data: param,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * đồng bộ danh mục CTMTDA, thay đổi danh mục tại các chứng từ liên quan
   * @returns 
   */
   async syncProjectBumas(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/syncProjectBumas',
      data: {
        ...param
      }
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thêm toàn bộ ctmtda từ bumas và xóa toàn bộ danh mục cũ
   * @returns 
   */
   async insertAllProjectBumasDeleteMimosa(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/insertAllProjectBumasDeleteMimosa',
      data: param,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thêm toàn bộ ctmtda từ bumas và xóa toàn bộ danh mục cũ
   * @returns 
   */
   async addProjectBumas(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/addProjectBumas',
      data: param,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thêm toàn bộ ctmtda từ bumas khi có phát sinh
   * @returns 
   */
   async addProjectBumasWhenArise(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/addProjectBumasWhenArise',
      data: param,
    };

    return await httpClient.postAsync(request);
  }
}

export default new ProjectAPI();
